<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="relative rounded-lg">

    <!-- TABELA DESKTOP -->
    <div class="hidden md:block overflow-x-auto">
    <table class="w-full text-sm text-left text-gray-500 mb-8">
        <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
            <tr class="text-left">
                <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('corporateName')">
                Razão Social
                <fa-icon [icon]="orderBy === 'corporateName' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                  [ngClass]="{'text-westetics-purple-800': orderBy === 'corporateName'}"></fa-icon>
              </th>

              <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('cnpj')">
                CNPJ
                <fa-icon [icon]="orderBy === 'cnpj' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                  [ngClass]="{'text-westetics-purple-800': orderBy === 'cnpj'}"></fa-icon>
              </th>

              <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('address.city')">
                Cidade
                <fa-icon [icon]="orderBy === 'address.city' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                  [ngClass]="{'text-westetics-purple-800': orderBy === 'address.city'}"></fa-icon>
              </th>

              <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('address.state')">
                Estado
                <fa-icon [icon]="orderBy === 'address.state' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                  [ngClass]="{'text-westetics-purple-800': orderBy === 'address.state'}"></fa-icon>
              </th>

              <th scope="col" class="px-5 py-2 font-medium cursor-pointer text-nowrap text-sm" (click)="toggleSort('isBlocked')">
                Status
                <fa-icon [icon]="orderBy === 'isBlocked' ? sortBy === 'ASC' ? faSortUp : faSortDown : faSort" class="ml-1"
                  [ngClass]="{'text-westetics-purple-800': orderBy === 'isBlocked'}"></fa-icon>
              </th>

              <th scope="col" class="px-5 py-2 font-medium">
              </th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let company of companies" class="border-b hover:bg-gray-50">
              <td class="p-4 text-sm text-westetics-neutral-950">
                {{company.corporate_name}}
              </td>
              <td class="p-4 text-sm text-westetics-neutral-950">
                {{company.cnpj | cnpj}}
              </td>
              <td class="p-4 text-sm text-westetics-neutral-950">
                {{company.address?.city || 'Não informado'}}
              </td>
              <td class="p-4 text-sm text-westetics-neutral-950">
                {{company.address?.state || 'Não informado'}}
              </td>
              <td class="p-4 text-sm text-westetics-neutral-950">
                <div *ngIf="company.is_blocked" class="px-3 py-1 rounded-full bg-red-100 text-red-600 text-nowrap text-xs inline-block">
                  <fa-icon [icon]="faCircle" size="2xs"></fa-icon>
                  Bloqueado
                </div>
                <div *ngIf="!company.is_blocked" class="px-1 py-1 rounded-full bg-westetics-purple-light text-westetics-purple-700 text-nowrap text-xs inline-block">
                  <fa-icon [icon]="faCircle" size="2xs"></fa-icon>
                  Ativo
                </div>
              </td>
              <td class="p-4 text-sm text-westetics-neutral-950">
                <div class="flex gap-3">
                    <button
                    (click)="edit(company.cnpj)"
                    class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M16.2812 3.9L14.4812 5.7H5.6999V18.3H18.2999V9.5187L20.0999 7.7187V19.2C20.0999 19.4387 20.0051 19.6676 19.8363 19.8364C19.6675 20.0052 19.4386 20.1 19.1999 20.1H4.7999C4.56121 20.1 4.33229 20.0052 4.16351 19.8364C3.99472 19.6676 3.8999 19.4387 3.8999 19.2V4.8C3.8999 4.5613 3.99472 4.33238 4.16351 4.1636C4.33229 3.99482 4.56121 3.9 4.7999 3.9H16.2812ZM19.6364 3.09L20.9099 4.3644L12.6371 12.6372L11.3663 12.6399L11.3645 11.3646L19.6364 3.09Z"
                            fill="currentColor"
                            />
                        </svg>
                    </button>


                    <button
                    (click)="showDeleteModal(company.cnpj)"
                    class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            d="M4.8 8.4H19.2V20.1C19.2 20.3387 19.1052 20.5676 18.9364 20.7364C18.7676 20.9052 18.5387 21 18.3 21H5.7C5.46131 21 5.23239 20.9052 5.0636 20.7364C4.89482 20.5676 4.8 20.3387 4.8 20.1V8.4ZM6.6 10.2V19.2H17.4V10.2H6.6ZM9.3 12H11.1V17.4H9.3V12ZM12.9 12H14.7V17.4H12.9V12ZM7.5 5.7V3.9C7.5 3.66131 7.59482 3.43239 7.7636 3.2636C7.93239 3.09482 8.1613 3 8.4 3H15.6C15.8387 3 16.0676 3.09482 16.2364 3.2636C16.4052 3.43239 16.5 3.66131 16.5 3.9V5.7H21V7.5H3V5.7H7.5ZM9.3 4.8V5.7H14.7V4.8H9.3Z"
                            fill="currentColor"
                            />
                        </svg>
                    </button>

                </div>
              </td>
            </tr>
          </tbody>
    </table>
    </div>

    <!-- CARDS MOBILE -->
    <div class="md:hidden space-y-3 mb-6">
        <div *ngFor="let company of companies" 
             class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow">
            <div class="flex justify-between items-start mb-3">
                <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ company.corporate_name }}</h3>
                    <p class="text-xs text-westetics-neutral-600">{{ company.cnpj | cnpj }}</p>
                </div>
                <div class="flex items-center gap-2">
                    <div *ngIf="company.is_blocked" class="px-2 py-0.5 rounded-full bg-red-100 text-red-600 text-xs">
                        Bloqueado
                    </div>
                    <div *ngIf="!company.is_blocked" class="px-2 py-0.5 rounded-full bg-westetics-purple-light text-westetics-purple-700 text-xs">
                        Ativo
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs mb-3">
                <div>
                    <span class="text-westetics-neutral-500">Cidade:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ company.address?.city || 'Não informado' }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">Estado:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ company.address?.state || 'Não informado' }}</span>
                </div>
            </div>
            <div class="flex justify-end gap-2 pt-2 border-t">
                <button
                    (click)="edit(company.cnpj)"
                    class="p-2 text-westetics-purple-800 hover:text-westetics-purple-600 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.2812 3.9L14.4812 5.7H5.6999V18.3H18.2999V9.5187L20.0999 7.7187V19.2C20.0999 19.4387 20.0051 19.6676 19.8363 19.8364C19.6675 20.0052 19.4386 20.1 19.1999 20.1H4.7999C4.56121 20.1 4.33229 20.0052 4.16351 19.8364C3.99472 19.6676 3.8999 19.4387 3.8999 19.2V4.8C3.8999 4.5613 3.99472 4.33238 4.16351 4.1636C4.33229 3.99482 4.56121 3.9 4.7999 3.9H16.2812ZM19.6364 3.09L20.9099 4.3644L12.6371 12.6372L11.3663 12.6399L11.3645 11.3646L19.6364 3.09Z" fill="currentColor" />
                    </svg>
                </button>
                <button
                    (click)="showDeleteModal(company.cnpj)"
                    class="p-2 text-westetics-purple-800 hover:text-westetics-purple-600 hover:bg-westetics-purple-50 rounded-lg transition-colors"
                >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.8 8.4H19.2V20.1C19.2 20.3387 19.1052 20.5676 18.9364 20.7364C18.7676 20.9052 18.5387 21 18.3 21H5.7C5.46131 21 5.23239 20.9052 5.0636 20.7364C4.89482 20.5676 4.8 20.3387 4.8 20.1V8.4ZM6.6 10.2V19.2H17.4V10.2H6.6ZM9.3 12H11.1V17.4H9.3V12ZM12.9 12H14.7V17.4H12.9V12ZM7.5 5.7V3.9C7.5 3.66131 7.59482 3.43239 7.7636 3.2636C7.93239 3.09482 8.1613 3 8.4 3H15.6C15.8387 3 16.0676 3.09482 16.2364 3.2636C16.4052 3.43239 16.5 3.66131 16.5 3.9V5.7H21V7.5H3V5.7H7.5ZM9.3 4.8V5.7H14.7V4.8H9.3Z" fill="currentColor" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <!-- Mensagem quando não há registros -->
    <div *ngIf="companies.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
        Nenhuma empresa encontrada.
    </div>

    <!-- PAGINADOR -->
    <div *ngIf="totalPages > 1" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
      <!-- Info de resultados -->
      <div class="text-xs lg:text-sm text-gray-600 order-3 lg:order-1">
        Mostrando {{ (currentPage * pageSize) + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} de {{ totalElements }} empresas
      </div>
      
      <!-- Controles de paginação -->
      <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
        <!-- Botão Anterior -->
        <button (click)="goToPreviousPage()" 
                [disabled]="currentPage === 0"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage === 0}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
          </svg>
        </button>
        
        <!-- Números das páginas -->
        <div class="flex items-center gap-1">
          <button *ngFor="let page of generatePagination(currentPage + 1, totalPages)"
                  (click)="navigateTo(page)"
                  [disabled]="page === '...'"
                  [ngClass]="{
                    'bg-westetics-purple-600 text-white': page === currentPage + 1,
                    'hover:bg-gray-50': page !== currentPage + 1 && page !== '...',
                    'cursor-default': page === '...'
                  }"
                  class="min-w-[32px] lg:min-w-[36px] px-2 lg:px-3 py-1.5 lg:py-2 border border-gray-300 rounded-md transition-colors text-xs lg:text-sm">
            {{ page }}
          </button>
        </div>
        
        <!-- Botão Próximo -->
        <button (click)="goToNextPage()" 
                [disabled]="currentPage + 1 >= totalPages"
                [ngClass]="{'opacity-50 cursor-not-allowed': currentPage + 1 >= totalPages}"
                class="p-2 lg:px-3 lg:py-2 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- Seletor de itens por página -->
      <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
        <span class="text-gray-600">Por página:</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)"
                class="px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-westetics-purple-500">
          <option *ngFor="let option of pageSizeOptions" [ngValue]="option.value">{{ option.label }}</option>
        </select>
      </div>
    </div>
</div>

<!-- Modal de confirmação de exclusão -->
<div *ngIf="showConfirmDeletePopup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg p-8 w-96 shadow-xl">
    <div class="flex justify-between items-center mb-6">
      <h1 class="font-bold text-xl text-westetics-neutral-950">Deletar Empresa</h1>
      <fa-icon 
        [icon]="faTimes" 
        (click)="closeDeleteModal()"
        class="cursor-pointer text-westetics-neutral-600 hover:text-westetics-neutral-900">
      </fa-icon>
    </div>
    <p class="text-sm text-westetics-neutral-800">Tem certeza que deseja deletar esta empresa? Esta ação não pode ser desfeita.</p>
    <div class="flex justify-end gap-3 mt-8">
      <button 
        type="button"
        (click)="closeDeleteModal()" 
        class=" cursor-pointer text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border font-medium rounded-lg px-4 py-2">
        Cancelar
      </button>
      <button 
        type="button"
        (click)="onDelete()"
        class="bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white cursor-pointer font-medium rounded-lg px-4 py-2">
        Deletar
      </button>
    </div>
  </div>
</div>
